var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var equal = function (a) { return function (b) { return a === b; }; };
export var findGroup = function (groups, objectType) { return groups.find(function (group) { return !!group.objectTypes.find(equal(objectType)); }); };
export var groupItems = function (items, groups) {
    return items
        .reduce(function (all, current) {
        var group = findGroup(groups, current.objectType);
        if (group) {
            if (all.find(function (item) { return !!item.objectTypes.find(equal(current.objectType)); })) {
                return all.map(function (item) {
                    if (item.objectTypes.find(equal(current.objectType))) {
                        var sources = item.sources;
                        item.sources.push(current);
                        return (__assign(__assign({}, item), { sources: sources }));
                    }
                    return item;
                });
            }
            else {
                all.push({
                    objectTypes: group.objectTypes,
                    label: group.name,
                    icon: group.icon,
                    sources: [current],
                });
            }
        }
        else {
            // ignore the
            console.log('no group for ', current);
        }
        return all;
    }, []);
};
export var toolTipForItem = function (item) {
    var _a;
    var toolTipHeader;
    var toolTipBody;
    if (typeof item === 'string') {
        toolTipHeader = item;
    }
    else {
        var tooltipDescription = typeof (item === null || item === void 0 ? void 0 : item.description) === 'string'
            ? item.description
            : ((_a = item === null || item === void 0 ? void 0 : item.description) === null || _a === void 0 ? void 0 : _a.plainTextValue) || '';
        if (!!item.name) {
            toolTipHeader = item.name;
        }
        if (!!tooltipDescription) {
            toolTipBody = "<br />" + tooltipDescription;
        }
    }
    return "<div><strong>" + toolTipHeader + "</strong>" + (toolTipBody || '') + "</div>";
};
export var combineItemsAndGroupHeaders = function (items, groups) {
    if (!items.find(function (item) { return typeof item !== 'string'; }) || groups.length === 0) {
        return items.map(function (i) { return ({ isHeader: false, item: i }); });
    }
    else {
        var dropDownItemObjects = items;
        var result_1 = [];
        groupItems(dropDownItemObjects, groups).forEach(function (container) {
            var group = __assign(__assign({}, container), { name: container.label });
            result_1.push({ isHeader: true, group: group });
            container.sources.forEach(function (i) {
                return result_1.push({ isHeader: false, item: i });
            });
        });
        return result_1;
    }
};
export var PADDING_SIZE = 8;
var MAX_VISIBLE_ITEMS = 7;
var MIN_VISIBLE_ITEMS = 3;
var getMinHeightBeforeScroll = function (itemHeight) { return (itemHeight * MIN_VISIBLE_ITEMS) + PADDING_SIZE; }; // top padding + min items
var getMaxHeight = function (itemHeight) { return (itemHeight * MAX_VISIBLE_ITEMS) + (PADDING_SIZE * 2); }; // top+bot padding + max items
var getHeightForItemCount = function (itemHeight, itemCount) { return (itemHeight * itemCount) + (PADDING_SIZE * 2); };
// Rules:
// 1. Prefer to display Dropdown downwards
// 2. There must be free space between the edge of the browser window and the edge of the dropdown equal to at least 1 row
// 3. There must be space to display at least 3 rows in the dropdown, unless the dropdown has fewer than 3 total rows.
export var getAvailableSpaceAndDirection = function (itemHeight, countOfItems, fixedPosition) {
    var minBlankSpaceBetweenDropdownAndWindowEdge = itemHeight;
    var heightOfContentsWithoutScroll = getHeightForItemCount(itemHeight, countOfItems);
    // Space of the entire content if fewer than MIN_VISIBLE_ITEMS, otherwise space for MIN_VISIBLE_ITEMS, + one row of empty space to the window edge
    var minRequiredSpace = Math.min(heightOfContentsWithoutScroll, getMinHeightBeforeScroll(itemHeight)) + minBlankSpaceBetweenDropdownAndWindowEdge;
    var availableSpaceDownwards = window.innerHeight - fixedPosition.openDownwardsY;
    var availableSpaceUpwards = fixedPosition.openUpwardsY;
    var willDisplayDownwards = availableSpaceDownwards >= minRequiredSpace || availableSpaceDownwards >= availableSpaceUpwards;
    var availableSpace = willDisplayDownwards ? availableSpaceDownwards : availableSpaceUpwards;
    return { availableSpace: availableSpace, willDisplayDownwards: willDisplayDownwards };
};
export var getDropDownHeight = function (itemHeight, countOfItems, availableSpace) {
    var minBlankSpaceBetweenDropdownAndWindowEdge = itemHeight;
    var heightWithoutScroll = getHeightForItemCount(itemHeight, countOfItems);
    var maxHeight = Math.min(heightWithoutScroll, getMaxHeight(itemHeight));
    return Math.min(maxHeight, availableSpace - minBlankSpaceBetweenDropdownAndWindowEdge);
};
export var getFixedPositionStyle = function (fixedPosition, willDisplayDownwards) {
    return {
        position: 'fixed',
        zIndex: 1305,
        minWidth: fixedPosition.width + 'px',
        width: fixedPosition.width + 'px',
        left: fixedPosition.x + 'px',
        top: willDisplayDownwards ? fixedPosition.openDownwardsY + 'px' : 'unset',
        bottom: willDisplayDownwards ? 'unset' : (window.innerHeight - fixedPosition.openUpwardsY) + 'px',
    };
};
//# sourceMappingURL=utils.js.map